import React, { Component } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { Header } from '../../Layout'
import {
  ChannelCreateModal,
  ChannelEditModal,
  ChannelDirectoryCreateModal,
  ChannelDirectoryEditModal,
  ChannelDirectorySmartCreateModal,
  ChannelDirectorySmartEditModal,

  StorageDeleteLinksModal,
  StorageUploadModal,
  StorageDeleteModal,
  StorageEditModal,
  StorageUpdateModal,
  ModalTagsManager,

  UserCreateModal,
  UserEditModal,
  UserDeleteModal,
  GroupCreateModal,
  GroupEditModal,
  GroupDeleteModal
} from '../../Modals'

export default class extends Component {
  render () {
    const { component: Component, auth, user, modal, ...rest } = this.props

    if (auth.isAuthenticated && this.props.roles && this.props.roles.indexOf(user.info.role) === -1) {
      return <Redirect to={'/admin'} />
    }

    return (
      <Route {...rest} render={props => (
        auth.isAuthenticated
          ? <div className='app'>
            <div className='app__wrapper'>
              <Header />
              <main className='content app__content'>
                <Component {...props} />
              </main>
            </div>
            <UserCreateModal />
            <UserEditModal />
            <UserDeleteModal />

            <GroupCreateModal />
            <GroupDeleteModal />
            <GroupEditModal />

            <ChannelCreateModal />

            { modal.channelEditModal &&
              <ChannelEditModal />
            }

            <ChannelDirectoryCreateModal />
            <ChannelDirectoryEditModal />

            <ChannelDirectorySmartCreateModal />

            { modal.channelDirectorySmartEditModal.status &&
              <ChannelDirectorySmartEditModal />
            }

            <StorageDeleteLinksModal />

            <StorageUploadModal />
            <StorageDeleteModal />
            <StorageUpdateModal />

            <StorageEditModal />

            { modal.tagsModal.status &&
              <ModalTagsManager />
            }
          </div>
          : <Redirect to='/login' />
      )}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Layout/PrivateRoute/PrivateRoute.jsx